.root {
  display: flex;
  column-gap: var(--spacingLg);
  width: 100%;
}

.highlightsLayout {
  flex: 1;
  min-height: unset;
  display: grid;
  grid-template-columns: fit-content(40%) 1fr;
  gap: var(--spacingSm) var(--spacingLg);
}
